import moment from 'moment';
import { z } from 'zod';

const base = z
    .object({
        orderDate: z.any().optional(),
        date: z.any().refine(val => moment.isMoment(val) && val.isValid(), { message: 'Date is required.' }),
        startTime: z.any().refine(val => moment.isMoment(val) && val.isValid(), { message: 'Start time is required.' }),
        endTime: z.any().optional()
    })
    .passthrough();

export const RESCHEDULE_VALIDATOR = z.preprocess((input, ctx) => {
    base.safeParse(input);
    const { date, startTime, endTime, orderDate } = input;
    let start = null;
    let end = null;

    if (date && startTime) {
        start = date.clone().set({
            hour: startTime.hour(),
            minute: startTime.minute(),
            second: startTime.second()
        });
    }

    if (date && endTime) {
        end = date.clone().set({
            hour: endTime.hour(),
            minute: endTime.minute(),
            second: endTime.second()
        });
    }

    // check if date is the orderDate is after 30 days
    if (date?.diff(moment(orderDate), 'days') > 30) {
        ctx.addIssue({
            path: ['date'],
            code: z.ZodIssueCode.custom,
            message: 'You can only select a date within 30 days of the first payment.'
        });
    }

    // check if date is the current date and startTime is before current time
    // MKTPLC-353: compare the actual calendar day, not the day-of-week. `day()`
    // returns 0-6, so the old check fired for ANY future date sharing today's
    // weekday and wrongly blocked valid reschedules.
    if (date && start) {
        if (date.isSame(moment(), 'day') && start.isBefore(moment().startOf('second'))) {
            ctx.addIssue({
                path: ['startTime'],
                code: z.ZodIssueCode.custom,
                message: 'Start time must not before current time.'
            });
        }
    }

    // MKTPLC-353: end time is optional — only validate it against the start when
    // the user actually picked one (`end` is null when endTime is omitted). This
    // keeps the form from submitting an inverted interval while still allowing an
    // empty end time.
    if (start && end && end.isBefore(start)) {
        ctx.addIssue({
            path: ['endTime'],
            code: z.ZodIssueCode.custom,
            message: 'End time must not be before start time.'
        });
    }

    return input;
}, base);
